/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Caps how many of an event may EARN inside a window, for the entity this is attached to. Omit entirely for no cap — an absent limit is not a limit of zero. The window is a fixed block at the authored granularity, opened by the player's first qualifying event, and it is never subdivided into a finer rate.
 * @export
 * @interface RateLimit
 */
export interface RateLimit {
    /**
     * Most events of this type that may earn inside one window.
     * @type {number}
     * @memberof RateLimit
     */
    max: number;
    /**
     * Window length in SECONDS. 300 = a 5-minute block.
     * @type {number}
     * @memberof RateLimit
     */
    per: number;
}

/**
 * Check if a given object implements the RateLimit interface.
 */
export function instanceOfRateLimit(value: object): value is RateLimit {
    if (!('max' in value) || value['max'] === undefined) return false;
    if (!('per' in value) || value['per'] === undefined) return false;
    return true;
}

export function RateLimitFromJSON(json: any): RateLimit {
    return RateLimitFromJSONTyped(json, false);
}

export function RateLimitFromJSONTyped(json: any, ignoreDiscriminator: boolean): RateLimit {
    if (json == null) {
        return json;
    }
    return {
        
        'max': json['max'],
        'per': json['per'],
    };
}

export function RateLimitToJSON(json: any): RateLimit {
    return RateLimitToJSONTyped(json, false);
}

export function RateLimitToJSONTyped(value?: RateLimit | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'max': value['max'],
        'per': value['per'],
    };
}

